import {createAction} from 'redux-actions';
import {CUSTOMER_FETCH, CUSTOMER_PATCH} from '../action-types';

export const patch = createAction(CUSTOMER_PATCH, (data, callServer = false) => {
	return callServer ? v12.customer.edit(data) : data;
});

export const fetch = createAction(CUSTOMER_FETCH, v12.customer.get);
